// removed by extract-text-webpack-plugin
module.exports = {"propertyRow":"_2EWh7IQYvTfLgfsQVD2sht","image":"dqPB7ku1uH06ORULs8Ud5","iconsWrapper":"cXLym95L24TK4M6M30GgW","labelVR":"_3Asa6WWlHbVqDxDWGECOTt","labelNew":"_2ljE49lVecSox9w0oYcZ7p","propertyDescription":"_17vtLvLR7iM_uSkhyYb_sV","propertyPrice":"_378YwjvF4TnKm6eiZmxFmt","propertyType":"_3qImf7CgHScE3DZkGIv2BM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/OMBaseMultiPinCell/OMBaseMultiPinCell.scss
// module id = 1667
// module chunks = 0